/* Pizeta — Cloudflare Turnstile injection su tutti i form di contatto/newsletter.
   Site key esposta via window.PZ_TURNSTILE_SITE_KEY (settata in theme.liquid).
   Widget iniettato automaticamente prima del bottone submit. Se il token non è
   presente al momento del submit, il submit viene bloccato con avviso. */
(function () {
  var SITE_KEY = window.PZ_TURNSTILE_SITE_KEY;
  if (!SITE_KEY) return;

  // Tutti i form Pizeta che vogliamo proteggere
  var FORM_SELECTORS = [
    '.pz-form__form',            // contact pagina + DPT + generico + modal DPT (5 istanze)
    '.pz-nl-form',               // newsletter footer/section
    '.pz-blog-grid__nl-form',    // newsletter blog grid
    '.pz-article__nl-form',      // newsletter blog article
  ].join(',');

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); return; }
    document.addEventListener('DOMContentLoaded', fn);
  }

  function inject(form) {
    if (form.dataset.pzTurnstile) return;
    form.dataset.pzTurnstile = '1';

    // Evita di iniettare in form dentro popup non ancora visibili di reset password ecc.
    if (form.closest('#recover, #login, [data-account-form]')) return;

    var widget = document.createElement('div');
    widget.className = 'cf-turnstile pz-turnstile-widget';
    widget.setAttribute('data-sitekey', SITE_KEY);
    widget.setAttribute('data-theme', 'light');
    widget.setAttribute('data-size', 'flexible');
    widget.style.marginTop = '12px';
    widget.style.marginBottom = '16px';

    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn && submitBtn.parentNode) {
      submitBtn.parentNode.insertBefore(widget, submitBtn);
    } else {
      form.appendChild(widget);
    }

    form.addEventListener('submit', function (e) {
      var response = form.querySelector('[name="cf-turnstile-response"]');
      var lang = document.documentElement.lang || 'it';
      var msg = lang.indexOf('en') === 0
        ? 'Please wait for the anti-bot verification before submitting.'
        : 'Per favore attendi la verifica anti-bot prima di inviare.';
      if (!response || !response.value) {
        e.preventDefault();
        e.stopPropagation();
        alert(msg);
      }
    }, true); // capture phase per intercettare prima di altri handler
  }

  function scanAndInject() {
    document.querySelectorAll(FORM_SELECTORS).forEach(inject);
  }

  ready(scanAndInject);

  // Re-scan quando Shopify carica dinamicamente sezioni (Theme Editor + Ajax cart re-render)
  document.addEventListener('shopify:section:load', scanAndInject);

  // Re-scan quando un modal si apre (es. modal DPT)
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) { scanAndInject(); break; }
    }
  });
  ready(function () { mo.observe(document.body, { childList: true, subtree: true }); });
})();
